import { NavLink, Routes, Route, Navigate } from 'react-router-dom';
import TopicsTab from '../components/analytics/TopicsTab';
import ForecastTab from '../components/analytics/ForecastTab';

function DataSciencePage() {
  const tabLinkClasses = ({ isActive }) =>
    `pb-4 px-2 font-medium transition ${
      isActive
        ? 'text-primary-600 border-b-2 border-primary-600'
        : 'text-gray-500 hover:text-gray-700'
    }`;

  return (
    <div className="px-6 py-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Data Science</h1>
        <p className="mt-1 text-gray-500">Topic modeling, clustering, and machine learning on your CRM data.</p>
      </div>

      {/* Sub-tab navigation */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="flex gap-4">
          <NavLink
            to="/data-science/topics"
            className={tabLinkClasses}
            data-testid="ds-tab-topics"
          >
            Topics
          </NavLink>
          <NavLink
            to="/data-science/forecast"
            className={tabLinkClasses}
            data-testid="ds-tab-forecast"
          >
            Forecast
          </NavLink>
        </nav>
      </div>

      <Routes>
        <Route index element={<Navigate to="topics" replace />} />
        <Route path="topics" element={<TopicsTab />} />
        <Route path="forecast/*" element={<ForecastTab />} />
        <Route path="*" element={<Navigate to="topics" replace />} />
      </Routes>
    </div>
  );
}

export default DataSciencePage;
